import { API, graphqlOperation } from "aws-amplify";

export default {
  data() {
    return {
      arePromocodesAvailable: false,
      promoCodeDetails: {
        success: null,
        discount: null,
        code: null,
        description: null,
        recurring: {
          discount: null,
          freeTrial: null
        }
      }
    };
  },
  methods: {
    async checkCodesAvailablity(tenantAlias, authMode) {
      try {
        const result = await API.graphql({
          ...graphqlOperation(
            `query CheckForAvailableCodes($tenantAlias: String!) {
              checkForAvailableCodes(tenantAlias: $tenantAlias){
                success
                 error
                   areCodesAvailable
              }
              }
              `,
            {
              tenantAlias: tenantAlias
            }
          ),
          authMode
        });

        const {
          success,
          areCodesAvailable
        } = result.data.checkForAvailableCodes;

        if (!success)
          throw new Error("checkForAvailableCodes: success = false");

        this.arePromocodesAvailable = areCodesAvailable;
      } catch (error) {
        this.$logger.error(error);
        this.arePromocodesAvailable = false;
      }
    }
  }
};
